import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=e071a742&scoped=true&"
import script from "./form-input.vue?vue&type=script&lang=js&"
export * from "./form-input.vue?vue&type=script&lang=js&"
import style0 from "./form-input.vue?vue&type=style&index=0&id=e071a742&prod&scoped=true&lang=less&"
import style1 from "./form-input.vue?vue&type=style&index=1&id=e071a742&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e071a742",
  null
  
)

export default component.exports